export const ENTRYPOINT = process.env.ENV.ENTRYPOINT;



// WEBPACK FOOTER //
// ./src/config/entrypoint.js